import React, { useState, useRef, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import NavbarForOnboardingForm from "./NavbarForOnbardingForm";

const saveFormDataToLocalStorage = (data) => {
  localStorage.setItem("onboardingFormData", JSON.stringify(data));
};

const loadFormDataFromLocalStorage = () => {
  const savedData = localStorage.getItem("onboardingFormData");

  return savedData ? JSON.parse(savedData) : null;
};

const clearFormDataFromLocalStorage = () => {
  localStorage.removeItem("onboardingFormData");
};
const OnboardingForm = () => {
  const navigate = useNavigate();

  const [personalInfo, setPersonalInfo] = useState({
    first_name: "",
    middle_name: "",
    last_name: "",
    email_id: "",
    phone_number: "",
    marital_status: "",
    gender: "",
    blood_group: "",
    nationality: "",
    permanent_address: "",
    current_address: "",
    aadhar_number: "",
    pan_number: "",
    date_of_birth: "",
    date_of_joining: "",
    anniversary_day: "",
    father_name: "",
    father_phone_number: "",
    mother_name: "",
    mother_phone_number: "",
    spouse_name: "",
    spouse_phone_number: "",
    spouse_blood_group: "",
    child1_name: "",
    child2_name: "",
  });

  const handlePersonalInfoChange = (e) => {
    const { name, value } = e.target;

    setPersonalInfo((prevInfo) => ({
      ...prevInfo,
      [name]: value,
    }));
  };

  const [emergencyContact1, setEmergencyContact1] = useState({
    name: "",
    phone_number: "",
    relation: "",
    language: "",
  });

  const [emergencyContact2, setEmergencyContact2] = useState({
    name: "",
    phone_number: "",
    relation: "",
    language: "",
  });

  const [employmentHistory, setEmploymentHistory] = useState([
    {
      company_name: "",
      employee_code_number: "",
      employee_designation: "",
      employee_department: "",
      manager_name: "",
      manager_email_id: "",
      manager_phone_number: "",
      employee_reference: "",
      ctc_joining: "",
      ctc_leaving: "",
      reasons_for_leaving: "",
      employee_responsibilities: "",
      employment_type: "",
      agency_details: "",
      company_address: "",
      employee_start_date: "",
      employee_end_date: "",
    },
  ]);
  const [educationHistory, setEducationHistory] = useState([
    {
      qualification: "",
      college_name: "",
      university_board_name: "",
      percentage_cgpa: "",
      university_roll_number: "",
      graduation_year: "",
      education_type: "",
      education_start_date: "",
      education_end_date: "",
    },
  ]);

  const handleEducationChange = (e, index) => {
    const { name, value } = e.target;
    const fieldName = name.split("-")[0]; // Get the actual field name like "qualification"
    const updatedEducationHistory = educationHistory.map((education, i) =>
      i === index ? { ...education, [fieldName]: value } : education
    );
    setEducationHistory(updatedEducationHistory);
  };
  const addEducationField = () => {
    setEducationHistory([
      ...educationHistory,
      {
        qualification: "",
        college_name: "",
        university_board_name: "",
        percentage_cgpa: "",
        university_roll_number: "",
        graduation_year: "",
        education_type: "",
        education_start_date: "",
        education_end_date: "",
      },
    ]);
  };

  const removeEducationField = (index) => {
    setEducationHistory(educationHistory.filter((_, i) => i !== index));
  };

  const handleEmploymentChange = (e, index) => {
    const { name, value } = e.target;

    const updatedEmploymentHistory = employmentHistory.map((employment, i) =>
      i === index ? { ...employment, [name]: value || "" } : employment
    );
    setEmploymentHistory(updatedEmploymentHistory);
  };

  const addEmploymentField = () => {
    setEmploymentHistory([
      ...employmentHistory,
      {
        company_name: "",
        employee_code_number: "",
        employee_designation: "",
        employee_department: "",
        manager_name: "",
        manager_email_id: "",
        manager_phone_number: "",
        employee_reference: "",
        ctc_joining: "",
        ctc_leaving: "",
        reasons_for_leaving: "",
        employee_responsibilities: "",
        employment_type: "",
        agency_details: "",
        company_address: "",
        employee_start_date: "",
        employee_end_date: "",
      },
    ]);
  };

  const removeEmploymentField = (index) => {
    setEmploymentHistory(employmentHistory.filter((_, i) => i !== index));
  };

  const [criminalRecord, setCriminalRecord] = useState({
    criminal_record: false,
    conviction_details: "",
    completed_rehabilitation: false,
    pending_cases: false,
  });

  const handleCriminalRecordChange = (event) => {
    const { name, value, type, checked } = event.target;
    setCriminalRecord((prev) => ({
      ...prev,
      [name]: type === "checkbox" ? checked : value,
    }));
  };

  const [healthRecord, setHealthRecord] = useState({
    medical_conditions: false,
    medical_conditions_details: "",
    recent_health_screening: false,
    health_screening_details: "",
    allergies_or_conditions: false,
    emergency_condition_details: "",
    health_check_consent: false,
  });

  const handleHealthRecordChange = (event) => {
    const { name, value, type, checked } = event.target;
    setHealthRecord((prev) => ({
      ...prev,
      [name]: type === "checkbox" ? checked : value,
    }));
  };

  const [isDeclarationChecked, setIsDeclarationChecked] = useState(false);

  const [uploadedDocuments, setUploadedDocuments] = useState({
    aadhar_card: null,
    pan_card: null,
    passport: null,
    visa: null,
    bank_passbook: null,
    resume: null,
    candidate_photo: null,
    tenth_marksheet: null,
    tenth_certificate: null,
    pu_marksheet: null,
    pu_certificate: null,
    degree_consolidated_marksheet: null,
    degree_certificate: null,
    post_degree_marksheet: null,
    post_degree_certificate: null,
    experience_letters: Array(3).fill(null), // Initial slots for last/current, 1st, and 2nd company
    relieving_letters: Array(3).fill(null),
  });

  const inputRef = useRef({});

  const handleFileChange = (e, docType, index = null) => {
    const file = e.target.files[0];

    setUploadedDocuments((prev) => {
      // Handle multiple files (e.g., degree documents)
      if (Array.isArray(prev[docType])) {
        const updatedFiles = [...prev[docType]];
        if (index !== null) {
          updatedFiles[index] = file; // Replace specific index
        } else {
          updatedFiles.push(file); // Add a new file
        }
        return { ...prev, [docType]: updatedFiles };
      }

      // Handle single files (e.g., aadhar_card)
      return { ...prev, [docType]: file };
    });
  };

  const clearFile = (docType, index = null) => {
    setUploadedDocuments((prev) => {
      // Handle multiple files
      if (Array.isArray(prev[docType])) {
        const updatedFiles = [...prev[docType]];
        if (index !== null) {
          updatedFiles[index] = null; // Clear specific file
        }
        return { ...prev, [docType]: updatedFiles };
      }

      // Handle single files
      return { ...prev, [docType]: null };
    });

    // Reset the input field value
    const inputElement =
      index !== null
        ? document.getElementsByName(`${docType}_${index}`)[0]
        : document.getElementsByName(docType)[0];

    if (inputElement) inputElement.value = ""; // Reset the file input
  };

  const [hasLoaded, setHasLoaded] = useState(false);

  const [primarySkills, setPrimarySkills] = useState([
    { skill_name: "", experience: "" },
  ]);
  const [secondarySkills, setSecondarySkills] = useState([
    { skill_name: "", experience: "" },
  ]);

  const handlePrimarySkillChange = (index, field, value) => {
    setPrimarySkills((prevSkills) =>
      prevSkills.map((skill, i) =>
        i === index ? { ...skill, [field]: value } : skill
      )
    );
  };

  const handleSecondarySkillChange = (index, field, value) => {
    setSecondarySkills((prevSkills) =>
      prevSkills.map((skill, i) =>
        i === index ? { ...skill, [field]: value } : skill
      )
    );
  };

  const addPrimarySkill = () =>
    setPrimarySkills([...primarySkills, { skill_name: "", experience: "" }]);
  const addSecondarySkill = () =>
    setSecondarySkills([
      ...secondarySkills,
      { skill_name: "", experience: "" },
    ]);

  // Load saved data on component mount
  useEffect(() => {
    const savedData = loadFormDataFromLocalStorage();
    if (savedData) {
      setPersonalInfo(savedData.personalInfo || {});
      setEmergencyContact1(savedData.emergencyContact1 || {});
      setEmergencyContact2(savedData.emergencyContact2 || {});
      setEmploymentHistory(savedData.employmentHistory || {});
      setEducationHistory(savedData.educationHistory || {});
      setCriminalRecord(savedData.criminalRecord || {});
      setHealthRecord(savedData.healthRecord || {});
      setUploadedDocuments(savedData.uploadedDocuments || {});
      setPrimarySkills(savedData.primarySkills || {});
      setSecondarySkills(savedData.secondarySkills || {});
    }
    setHasLoaded(true);
  }, []);

  const handleSaveDraft = () => {
    const formData = {
      personalInfo,
      emergencyContact1,
      emergencyContact2,
      employmentHistory,
      educationHistory,
      criminalRecord,
      healthRecord,
      uploadedDocuments,
      primarySkills,
      secondarySkills,
    };
    saveFormDataToLocalStorage(formData);
    alert("Draft saved successfully.");
  };

  const handleSubmit = async (event) => {
    event.preventDefault();
    clearFormDataFromLocalStorage();

    // Confirmation dialog
    const isConfirmed = window.confirm(
      "Are you sure you want to submit this form? Once submitted, you will not be able to edit or modify it."
    );

    if (!isConfirmed) {
      return; // Exit if the user cancels
    }

    if (!isDeclarationChecked) {
      alert("You must agree to the declaration before submitting.");
      return;
    }

    // Ensure blank fields in the personalInfo section are set to null
    const cleanPersonalInfo = Object.keys(personalInfo).reduce((acc, key) => {
      acc[key] = personalInfo[key] === "" ? null : personalInfo[key];
      return acc;
    }, {});

    console.log("Cleaned Personal Info:", cleanPersonalInfo);

    const fileData = new FormData();
    Object.keys(uploadedDocuments).forEach((key) => {
      if (Array.isArray(uploadedDocuments[key])) {
        uploadedDocuments[key].forEach((file) => {
          if (file) {
            fileData.append(key, file);
          }
        });
      } else if (uploadedDocuments[key]) {
        fileData.append(key, uploadedDocuments[key]);
      }
    });

    try {
      // Step 1: Submit personalInfo and retrieve the ID
      const personalInfoResponse = await fetch(
        `${process.env.REACT_APP_API_BASE_URL}/bgv_form/personal-info/`,
        {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify(cleanPersonalInfo),
        }
      );

      console.log(cleanPersonalInfo);
      const personalInfoData = await personalInfoResponse.json();

      if (!personalInfoResponse.ok) {
        throw new Error(
          `Personal info submission failed: ${JSON.stringify(personalInfoData)}`
        );
      }

      const personalInfoId = personalInfoData.data.id;

      // Step 2: Submit each employment history entry individually
      for (let history of employmentHistory) {
        const employmentPayload = {
          ...history,
          personal_info: personalInfoId,
        };

        const employmentResponse = await fetch(
          `${process.env.REACT_APP_API_BASE_URL}/bgv_form/employment-history/`,
          {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify(employmentPayload),
          }
        );
        if (!employmentResponse.ok) {
          const errorData = await employmentResponse.json();
          throw new Error(
            `Employment history submission failed: ${JSON.stringify(errorData)}`
          );
        }
      }

      // Step 3: Submit each education history entry individually
      for (let history of educationHistory) {
        const educationResponse = await fetch(
          `${process.env.REACT_APP_API_BASE_URL}/bgv_form/education-history/`,
          {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({ ...history, personal_info: personalInfoId }),
          }
        );
        if (!educationResponse.ok) {
          const errorData = await educationResponse.json();
          throw new Error(
            `Education history submission failed: ${JSON.stringify(errorData)}`
          );
        }
      }

      // Step 4: Submit emergency contacts
      const emergencyContacts = [
        {
          name: emergencyContact1.emergency_contact1_name,
          phone_number: emergencyContact1.emergency_contact1_phone_number,
          relation: emergencyContact1.emergency_contact1_relation,
          language: emergencyContact1.emergency_contact1_language,
          personal_info: personalInfoId,
        },
        {
          name: emergencyContact2.emergency_contact2_name,
          phone_number: emergencyContact2.emergency_contact2_phone_number,
          relation: emergencyContact2.emergency_contact2_relation,
          language: emergencyContact2.emergency_contact2_language,
          personal_info: personalInfoId,
        },
      ];

      for (let contact of emergencyContacts) {
        try {
          const response = await fetch(
            `${process.env.REACT_APP_API_BASE_URL}/bgv_form/emergency-contacts/`,
            {
              method: "POST",
              headers: { "Content-Type": "application/json" },
              body: JSON.stringify(contact),
            }
          );

          if (!response.ok) {
            const errorData = await response.json();
            console.error("Error creating Emergency Contact:", errorData); // Debug output
            throw new Error(
              `Emergency contact submission failed: ${JSON.stringify(
                errorData
              )}`
            );
          }
        } catch (error) {
          console.error(error.message); // Show error message in console
        }
      }

      // Step 5: Submit the criminal record
      const criminalRecordPayload = {
        ...criminalRecord,
        personal_info: personalInfoId,
      };
      const criminalRecordResponse = await fetch(
        `${process.env.REACT_APP_API_BASE_URL}/bgv_form/criminal-record/`,
        {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify(criminalRecordPayload),
        }
      );

      if (!criminalRecordResponse.ok) {
        const errorData = await criminalRecordResponse.json();
        throw new Error(
          `Criminal record submission failed: ${JSON.stringify(errorData)}`
        );
      }

      // Step 6: Submit health record
      const healthRecordResponse = await fetch(
        `${process.env.REACT_APP_API_BASE_URL}/bgv_form/health-record/`,
        {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({
            ...healthRecord,
            personal_info: personalInfoId,
          }),
        }
      );
      if (!healthRecordResponse.ok) {
        const errorData = await healthRecordResponse.json();
        throw new Error(
          `Health record submission failed: ${JSON.stringify(errorData)}`
        );
      }

      // Step 7: Submit uploaded general documents and each experience and relieving letter individually
      // First, upload general documents
      fileData.append("personal_info", personalInfoId);

      const fileResponse = await fetch(
        `${process.env.REACT_APP_API_BASE_URL}/bgv_form/uploaded-documents/`,
        {
          method: "POST",
          body: fileData,
        }
      );

      const fileDataResponse = await fileResponse.json();
      if (!fileResponse.ok) {
        throw new Error(
          `File upload submission failed: ${JSON.stringify(fileDataResponse)}`
        );
      }

      const uploadedDocumentId = fileDataResponse.data.id;

      console.log("Uploaded Document ID:", uploadedDocumentId);

      // Next, upload experience and relieving letters
      const experienceTypes = ["experience_letters", "relieving_letters"];
      for (const type of experienceTypes) {
        if (Array.isArray(uploadedDocuments[type])) {
          for (const file of uploadedDocuments[type]) {
            if (file instanceof File) {
              const experienceRelievingData = new FormData();
              experienceRelievingData.append(
                "uploaded_document",
                uploadedDocumentId
              );
              experienceRelievingData.append(
                "document_type",
                type === "experience_letters" ? "experience" : "relieving"
              );
              experienceRelievingData.append("file", file);

              // Add these console.log statements to inspect FormData
              console.log(`Preparing to upload ${type} document:`, {
                uploaded_document: uploadedDocumentId,
                document_type:
                  type === "experience_letters" ? "experience" : "relieving",
                file: file.name,
              });

              // Alternatively, iterate through FormData entries
              for (const [key, value] of experienceRelievingData.entries()) {
                console.log(`${key}:`, value);
              }

              const experienceRelievingResponse = await fetch(
                `${process.env.REACT_APP_API_BASE_URL}/bgv_form/experiencerelievingdocument/`,
                {
                  method: "POST",
                  body: experienceRelievingData,
                }
              );

              const experienceRelievingDataResponse =
                await experienceRelievingResponse.json();
              if (!experienceRelievingResponse.ok) {
                throw new Error(
                  `Error uploading ${type} document: ${JSON.stringify(
                    experienceRelievingDataResponse
                  )}`
                );
              }

              console.log(
                `${type} document uploaded successfully: ${file.name}`
              );
            }
          }
        } else {
          console.error(`No valid files found for ${type}`);
        }
      }

      // Step 8: Submit Skills
      // Validate and clean skills
      const validateSkills = (skills) => {
        return skills
          .filter((skill) => skill.skill_name && skill.experience)
          .map((skill) => ({
            ...skill,
            experience: parseFloat(skill.experience), // Convert experience to an Float
          }));
      };

      const skillsPayload = {
        primary_skills: validateSkills(primarySkills),
        secondary_skills: validateSkills(secondarySkills),
        personal_info: personalInfoId,
      };

      if (
        !skillsPayload.primary_skills.length &&
        !skillsPayload.secondary_skills.length
      ) {
        alert("Please provide at least one valid skill.");
        return;
      }

      console.log("Skills Payload:", skillsPayload);
      const skillsResponse = await fetch(
        `${process.env.REACT_APP_API_BASE_URL}/bgv_form/skillview/`,
        {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify(skillsPayload),
        }
      );

      if (!skillsResponse.ok)
        throw new Error(
          `Skills submission failed: ${JSON.stringify(
            await skillsResponse.json()
          )}`
        );

      console.log("All form sections submitted successfully.");
      navigate("/success");
    } catch (error) {
      console.error("Error submitting form:", error);
      alert(error.message);
    }
  };

  return (
    <>
      <NavbarForOnboardingForm />
      <div className="container my-3">
        <h2 className="text-center">Employee Onboarding Form</h2>
        <form onSubmit={handleSubmit}>
          {/* Personal Information */}

          <section className="form-section">
            <h3 className="section-title">Personal Information</h3>

            {/* Candidate Information */}
            <div className="row mb-2">
              <div className="col-md-2 d-flex align-items-start text-center">
                <h5 className="mt-5">Candidate Details</h5>
              </div>
              <div className="col-md-10">
                <div className="row">
                  <div className="col-md-3 mb-2">
                    <input
                      type="text"
                      name="first_name"
                      className="form-control"
                      placeholder="First Name"
                      value={personalInfo.first_name || ""}
                      onChange={handlePersonalInfoChange}
                    />
                  </div>
                  <div className="col-md-3 mb-2">
                    <input
                      type="text"
                      name="middle_name"
                      className="form-control"
                      placeholder="Middle Name"
                      value={personalInfo.middle_name || ""}
                      onChange={handlePersonalInfoChange}
                    />
                  </div>
                  <div className="col-md-3 mb-2">
                    <input
                      type="text"
                      name="last_name"
                      className="form-control"
                      placeholder="Last Name"
                      value={personalInfo.last_name || ""}
                      onChange={handlePersonalInfoChange}
                    />
                  </div>
                </div>

                <div className="row">
                  <div className="col-md-3 mb-2">
                    <input
                      type="email"
                      name="email_id"
                      className="form-control"
                      placeholder="Email ID"
                      value={personalInfo.email_id || ""}
                      onChange={handlePersonalInfoChange}
                    />
                  </div>
                  <div className="col-md-3 mb-2">
                    <input
                      type="tel"
                      name="phone_number"
                      className="form-control"
                      placeholder="Phone Number"
                      value={personalInfo.phone_number || ""}
                      onChange={handlePersonalInfoChange}
                    />
                  </div>
                  <div className="col-md-3 mb-2">
                    <input
                      type="text"
                      name="marital_status"
                      className="form-control"
                      placeholder="Marital Status"
                      value={personalInfo.marital_status || ""}
                      onChange={handlePersonalInfoChange}
                    />
                  </div>

                  <div className="col-md-3 mb-2">
                    <input
                      type="text"
                      name="gender"
                      className="form-control"
                      placeholder="Gender"
                      value={personalInfo.gender || ""}
                      onChange={handlePersonalInfoChange}
                    />
                  </div>
                </div>

                <div className="row">
                  <div className="col-md-3 mb-2">
                    <input
                      type="text"
                      name="blood_group"
                      className="form-control"
                      placeholder="Blood Group"
                      value={personalInfo.blood_group || ""}
                      onChange={handlePersonalInfoChange}
                    />
                  </div>
                  <div className="col-md-3 mb-2">
                    <input
                      type="text"
                      name="nationality"
                      className="form-control"
                      placeholder="Nationality"
                      value={personalInfo.nationality || ""}
                      onChange={handlePersonalInfoChange}
                    />
                  </div>
                  <div className="col-md-3 mb-2">
                    <textarea
                      name="current_address"
                      className="form-control"
                      placeholder="Current Address"
                      rows={1}
                      value={personalInfo.current_address || ""}
                      onChange={handlePersonalInfoChange}
                    ></textarea>
                  </div>
                  <div className="col-md-3 mb-2">
                    <textarea
                      name="permanent_address"
                      className="form-control"
                      placeholder="Permanent Address"
                      rows={1}
                      value={personalInfo.permanent_address || ""}
                      onChange={handlePersonalInfoChange}
                    ></textarea>
                  </div>
                </div>
                <div className="row">
                  <div className="col-md-3 mb-2">
                    <input
                      type="text"
                      name="aadhar_number"
                      className="form-control"
                      placeholder="Aadhar Number"
                      value={personalInfo.aadhar_number || ""}
                      onChange={handlePersonalInfoChange}
                    />
                  </div>
                  <div className="col-md-3 mb-2">
                    <input
                      type="text"
                      name="pan_number"
                      className="form-control"
                      placeholder="Pan Number"
                      value={personalInfo.pan_number || ""}
                      onChange={handlePersonalInfoChange}
                    />
                  </div>
                </div>
                <div className="row text-center">
                  <div className="col-md-3">
                    <label htmlFor="date_of_birth" className="form-label">
                      Date of Birth
                    </label>
                    <input
                      type="date"
                      name="date_of_birth"
                      className="form-control"
                      placeholder="Date of Birth"
                      value={personalInfo.date_of_birth || ""}
                      onChange={handlePersonalInfoChange}
                    />
                  </div>
                  <div className="col-md-3">
                    <label htmlFor="date_of_joining" className="form-label">
                      Date of Joining
                    </label>
                    <input
                      type="date"
                      name="date_of_joining"
                      className="form-control"
                      placeholder="Date of Joining"
                      value={personalInfo.date_of_joining || ""}
                      onChange={handlePersonalInfoChange}
                    />
                  </div>
                  <div className="col-md-3">
                    <label htmlFor="anniversary_day" className="form-label">
                      Anniversary Day
                    </label>
                    <input
                      type="date"
                      name="anniversary_day"
                      className="form-control"
                      placeholder="Anniversary Day"
                      value={personalInfo.anniversary_day || ""}
                      onChange={handlePersonalInfoChange}
                    />
                  </div>
                </div>
              </div>
            </div>

            {/* Father's Information */}
            <div className="row">
              <div className="col-md-2 d-flex align-items-start">
                <h5 className="mt-1">Father's Details</h5>
              </div>
              <div className="col-md-10">
                <div className="row">
                  <div className="col-md-3 mb-2">
                    <input
                      type="text"
                      name="father_name"
                      className="form-control"
                      placeholder="Father's Name"
                      value={personalInfo.father_name || ""}
                      onChange={handlePersonalInfoChange}
                    />
                  </div>
                  <div className="col-md-3 mb-2">
                    <input
                      type="text"
                      name="father_phone_number"
                      className="form-control"
                      placeholder="Father's Phone Number"
                      value={personalInfo.father_phone_number || ""}
                      onChange={handlePersonalInfoChange}
                    />
                  </div>
                </div>
              </div>
            </div>

            {/* Mother's Information */}
            <div className="row">
              <div className="col-md-2 d-flex align-items-start">
                <h5 className="mt-1">Mother's Details</h5>
              </div>
              <div className="col-md-10">
                <div className="row">
                  <div className="col-md-3 mb-2">
                    <input
                      type="text"
                      name="mother_name"
                      className="form-control"
                      placeholder="Mother's Name"
                      value={personalInfo.mother_name || ""}
                      onChange={handlePersonalInfoChange}
                    />
                  </div>
                  <div className="col-md-3 mb-2">
                    <input
                      type="text"
                      name="mother_phone_number"
                      className="form-control"
                      placeholder="Mother's Phone Number"
                      value={personalInfo.mother_phone_number || ""}
                      onChange={handlePersonalInfoChange}
                    />
                  </div>
                </div>
              </div>
            </div>

            {/* Spouse's Information */}
            <div className="row">
              <div className="col-md-2 d-flex align-items-start">
                <h5 className="mt-1">Spouse's Details</h5>
              </div>
              <div className="col-md-10">
                <div className="row">
                  <div className="col-md-3 mb-2">
                    <input
                      type="text"
                      name="spouse_name"
                      className="form-control"
                      placeholder="Spouse's Name"
                      value={personalInfo.spouse_name || ""}
                      onChange={handlePersonalInfoChange}
                    />
                  </div>
                  <div className="col-md-3 mb-2">
                    <input
                      type="text"
                      name="spouse_phone_number"
                      className="form-control"
                      placeholder="Phone Number"
                      value={personalInfo.spouse_phone_number || ""}
                      onChange={handlePersonalInfoChange}
                    />
                  </div>

                  <div className="col-md-3 mb-2">
                    <input
                      type="text"
                      name="spouse_blood_group"
                      className="form-control"
                      placeholder="Blood Group"
                      value={personalInfo.spouse_blood_group || ""}
                      onChange={handlePersonalInfoChange}
                    />
                  </div>
                </div>
              </div>
            </div>

            {/* Child Information */}
            <div className="row">
              <div className="col-md-2 d-flex align-items-start">
                <h5 className="mt-1">Child Details</h5>
              </div>
              <div className="col-md-10">
                <div className="row">
                  <div className="col-md-3 mb-2">
                    <input
                      type="text"
                      name="child1_name"
                      className="form-control"
                      placeholder="Child 1 Name"
                      value={personalInfo.child1_name || ""}
                      onChange={handlePersonalInfoChange}
                    />
                  </div>

                  <div className="col-md-3">
                    <input
                      type="text"
                      name="child2_name"
                      className="form-control"
                      placeholder="Child 2 Name"
                      value={personalInfo.child2_name || ""}
                      onChange={handlePersonalInfoChange}
                    />
                  </div>
                </div>
              </div>
            </div>
          </section>

          <hr />

          {/* Other sections like Emergency, Employment and Education History can go here */}
          <section className="form-section">
            <div className="row">
              <div className="col-md-2 d-flex align-items-start">
                <h5 className="">Emergency Contact 1</h5>
              </div>
              <div className="col-md-10">
                <div className="row">
                  <div className="col-md-3 mb-2">
                    <div className="form-group">
                      <input
                        type="text"
                        className="form-control"
                        placeholder="Name"
                        name="emergency_contact1_name"
                        value={emergencyContact1?.emergency_contact1_name || ""}
                        onChange={(e) =>
                          setEmergencyContact1({
                            ...emergencyContact1,
                            emergency_contact1_name: e.target.value,
                          })
                        }
                      />
                    </div>
                  </div>
                  <div className="col-md-3 mb-2">
                    <div className="form-group">
                      <input
                        type="tel"
                        className="form-control"
                        placeholder="Phone Number"
                        name="emergency_contact1_phone_number"
                        value={
                          emergencyContact1?.emergency_contact1_phone_number ||
                          ""
                        }
                        onChange={(e) =>
                          setEmergencyContact1({
                            ...emergencyContact1,
                            emergency_contact1_phone_number: e.target.value,
                          })
                        }
                      />
                    </div>
                  </div>
                  <div className="col-md-3 mb-2">
                    <div className="form-group">
                      <input
                        type="text"
                        className="form-control"
                        placeholder="Relation"
                        name="emergency_contact1_relation"
                        value={
                          emergencyContact1?.emergency_contact1_relation || ""
                        }
                        onChange={(e) =>
                          setEmergencyContact1({
                            ...emergencyContact1,
                            emergency_contact1_relation: e.target.value,
                          })
                        }
                      />
                    </div>
                  </div>
                  <div className="col-md-3">
                    <input
                      type="text"
                      name="emergency_contact1_language"
                      className="form-control"
                      placeholder="Preferred Language"
                      value={
                        emergencyContact1?.emergency_contact1_language || ""
                      }
                      onChange={(e) =>
                        setEmergencyContact1({
                          ...emergencyContact1,
                          emergency_contact1_language: e.target.value,
                        })
                      }
                    />
                  </div>
                </div>
              </div>
            </div>

            {/* Second Emergency Contact */}
            <div className="row mt-1">
              <div className="col-md-2 d-flex align-items-start">
                <h5 className="">Emergency Contact 2</h5>
              </div>
              <div className="col-md-10">
                <div className="row">
                  <div className="col-md-3 mb-2">
                    <div className="form-group">
                      <input
                        type="text"
                        className="form-control"
                        placeholder="Name"
                        name="emergency_contact2_name"
                        value={emergencyContact2?.emergency_contact2_name || ""}
                        onChange={(e) =>
                          setEmergencyContact2({
                            ...emergencyContact2,
                            emergency_contact2_name: e.target.value,
                          })
                        }
                      />
                    </div>
                  </div>
                  <div className="col-md-3 mb-2">
                    <div className="form-group">
                      <input
                        type="tel"
                        className="form-control"
                        placeholder="Phone Number"
                        name="emergency_contact2_phone_number"
                        value={
                          emergencyContact2?.emergency_contact2_phone_number ||
                          ""
                        }
                        onChange={(e) =>
                          setEmergencyContact2({
                            ...emergencyContact2,
                            emergency_contact2_phone_number: e.target.value,
                          })
                        }
                      />
                    </div>
                  </div>
                  <div className="col-md-3 mb-2">
                    <div className="form-group">
                      <input
                        type="text"
                        className="form-control"
                        placeholder="Relation"
                        name="emergency_contact2_relation"
                        value={
                          emergencyContact2?.emergency_contact2_relation || ""
                        }
                        onChange={(e) =>
                          setEmergencyContact2({
                            ...emergencyContact2,
                            emergency_contact2_relation: e.target.value,
                          })
                        }
                      />
                    </div>
                  </div>
                  <div className="col-md-3">
                    <input
                      type="text"
                      name="emergency_contact2_language"
                      className="form-control"
                      placeholder="Preferred Language"
                      value={
                        emergencyContact2?.emergency_contact2_language || ""
                      }
                      onChange={(e) =>
                        setEmergencyContact2({
                          ...emergencyContact2,
                          emergency_contact2_language: e.target.value,
                        })
                      }
                    />
                  </div>
                </div>
              </div>
            </div>
          </section>

          <hr />

          {/* Section: Employment */}

          <section className="form-section">
            <h4 className="section-title">
              Employment History{" "}
              <button
                type="button"
                className="btn btn-outline-primary"
                onClick={addEmploymentField}
              >
                <i className="fa-solid fa-circle-plus fa-2xl"></i>
              </button>
            </h4>
            {employmentHistory.map((employment, index) => (
              <div key={index} className="border-none p-3 mb-3 row">
                <div className="col-md-2 d-flex align-items-start">
                  <h5 className="section-subtitle">
                    {index === 0
                      ? "Current Employment"
                      : `Previous Employment ${index}`}{" "}
                    <button
                      type="button"
                      className="btn btn-outline-danger mt-2"
                      onClick={() => removeEmploymentField(index)}
                    >
                      <i className="fas fa-trash"></i>
                    </button>
                  </h5>
                </div>
                <div className="col-md-10">
                  <div className="row">
                    <div className="col-md-3 mb-2">
                      <div className="form-group">
                        <input
                          type="text"
                          name="company_name"
                          className="form-control"
                          placeholder="Company Name"
                          value={employment.company_name}
                          onChange={(e) => handleEmploymentChange(e, index)}
                        />
                      </div>
                    </div>
                    <div className="col-md-3 mb-2">
                      <div className="form-group">
                        <input
                          type="text"
                          name="employee_code_number"
                          className="form-control"
                          placeholder="Employee Code/No"
                          value={employment.employee_code_number}
                          onChange={(e) => handleEmploymentChange(e, index)}
                        />
                      </div>
                    </div>
                    <div className="col-md-3 mb-2">
                      <div className="form-group">
                        <input
                          type="text"
                          name="employee_designation"
                          className="form-control"
                          placeholder="Designation"
                          value={employment.employee_designation}
                          onChange={(e) => handleEmploymentChange(e, index)}
                        />
                      </div>
                    </div>
                    <div className="col-md-3 mb-2">
                      <div className="form-group">
                        <input
                          type="text"
                          name="employee_department"
                          className="form-control"
                          placeholder="Department"
                          value={employment.employee_department}
                          onChange={(e) => handleEmploymentChange(e, index)}
                        />
                      </div>
                    </div>
                  </div>

                  <div className="row">
                    <div className="col-md-3 mb-2">
                      <div className="form-group">
                        <input
                          type="text"
                          className="form-control"
                          name="manager_name"
                          placeholder="Manager's Name"
                          value={employment.manager_name}
                          onChange={(e) => handleEmploymentChange(e, index)}
                        />
                      </div>
                    </div>
                    <div className="col-md-3 mb-2">
                      <div className="form-group">
                        <input
                          type="text"
                          className="form-control"
                          name="manager_email_id"
                          placeholder="Manager's Email ID"
                          value={employment.manager_email_id}
                          onChange={(e) => handleEmploymentChange(e, index)}
                        />
                      </div>
                    </div>
                    <div className="col-md-3 mb-2">
                      <div className="form-group">
                        <input
                          type="text"
                          className="form-control"
                          name="manager_phone_number"
                          placeholder="Manager's Phone Number"
                          value={employment.manager_phone_number}
                          onChange={(e) => handleEmploymentChange(e, index)}
                        />
                      </div>
                    </div>
                    <div className="col-md-3 mb-2">
                      <div className="form-group">
                        <input
                          type="text"
                          className="form-control"
                          name="employee_reference"
                          placeholder="Reference taken now (Yes/No)"
                          value={employment.employee_reference}
                          onChange={(e) => handleEmploymentChange(e, index)}
                        />
                      </div>
                    </div>
                  </div>

                  <div className="row">
                    <div className="col-md-3 mb-2">
                      <div className="form-group">
                        <input
                          type="text"
                          className="form-control"
                          name="ctc_joining"
                          placeholder="CTC While Joining"
                          value={employment.ctc_joining}
                          onChange={(e) => handleEmploymentChange(e, index)}
                        />
                      </div>
                    </div>
                    <div className="col-md-3 mb-2">
                      <div className="form-group">
                        <input
                          type="text"
                          className="form-control"
                          name="ctc_leaving"
                          placeholder="CTC While Leaving"
                          value={employment.ctc_leaving}
                          onChange={(e) => handleEmploymentChange(e, index)}
                        />
                      </div>
                    </div>
                  </div>

                  <div className="row">
                    <div className="col-md-3 mb-2">
                      <div className="form-group">
                        <textarea
                          type="text"
                          className="form-control"
                          name="reasons_for_leaving"
                          placeholder="Reasons for Leaving"
                          value={employment.reasons_for_leaving}
                          onChange={(e) => handleEmploymentChange(e, index)}
                          rows={1}
                        />
                      </div>
                    </div>
                    <div className="col-md-3 mb-2">
                      <div className="form-group">
                        <textarea
                          type="text"
                          className="form-control"
                          name="employee_responsibilities"
                          placeholder="Responsibilities"
                          value={employment.employee_responsibilities}
                          onChange={(e) => handleEmploymentChange(e, index)}
                          rows={1}
                        />
                      </div>
                    </div>
                  </div>

                  <div className="row">
                    <div className="col-md-3 mb-2">
                      <div className="form-group">
                        <input
                          type="text"
                          className="form-control"
                          name="employment_type"
                          placeholder="Employment Type"
                          value={employment.employment_type}
                          onChange={(e) => handleEmploymentChange(e, index)}
                        />
                      </div>
                    </div>
                    <div className="col-md-3 mb-2">
                      <div className="form-group">
                        <textarea
                          type="text"
                          className="form-control"
                          name="agency_details"
                          placeholder="Agency Details (if temporary/contractual)"
                          rows={1}
                          value={employment.agency_details}
                          onChange={(e) => handleEmploymentChange(e, index)}
                        />
                      </div>
                    </div>
                    <div className="col-md-3 mb-2">
                      <div className="form-group">
                        <textarea
                          type="text"
                          className="form-control"
                          name="company_address"
                          placeholder="Address of Current Employer"
                          rows={1}
                          value={employment.company_address || ""}
                          onChange={(e) => handleEmploymentChange(e, index)}
                        />
                      </div>
                    </div>
                  </div>

                  <div className="row text-center">
                    <div className="col-md-3">
                      <div className="form-group">
                        <label className="form-label">Start Date</label>
                        <input
                          type="date"
                          className="form-control"
                          name="employee_start_date"
                          value={employment.employee_start_date}
                          onChange={(e) => handleEmploymentChange(e, index)}
                        />
                      </div>
                    </div>
                    <div className="col-md-3">
                      <div className="form-group">
                        <label className="form-label">End Date</label>
                        <input
                          type="date"
                          className="form-control"
                          name="employee_end_date"
                          value={employment.employee_end_date}
                          onChange={(e) => handleEmploymentChange(e, index)}
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            ))}
          </section>

          <hr />

          {/* Section: Education */}

          <section className="form-section">
            <h4 className="section-title">
              Education History{" "}
              <button
                type="button"
                className="btn btn-outline-primary"
                onClick={addEducationField}
              >
                <i className="fa-solid fa-circle-plus fa-2xl"></i>
              </button>
            </h4>

            {educationHistory.map((education, index) => (
              <div
                key={index}
                className="border border-dark p-2 mb-3 text-center"
              >
                <div className="row">
                  <div className="col-md-4 mb-2">
                    <div className="form-group">
                      <input
                        type="text"
                        name={`qualification-${index}`}
                        value={education.qualification || ""}
                        className="form-control"
                        placeholder="Post Graduation, Degree, PU, SSLC"
                        onChange={(e) => handleEducationChange(e, index)}
                      />
                    </div>
                  </div>

                  <div className="col-md-4 mb-2">
                    <div className="form-group">
                      <input
                        type="text"
                        name={`college_name-${index}`}
                        value={education.college_name || ""}
                        className="form-control"
                        placeholder="College Name"
                        onChange={(e) => handleEducationChange(e, index)}
                      />
                    </div>
                  </div>

                  <div className="col-md-4 mb-2">
                    <div className="form-group">
                      <input
                        type="text"
                        name={`university_board_name-${index}`}
                        value={education.university_board_name || ""}
                        className="form-control"
                        placeholder="University/Board Name"
                        onChange={(e) => handleEducationChange(e, index)}
                      />
                    </div>
                  </div>
                </div>

                <div className="row">
                  <div className="col-md-4 mb-2">
                    <div className="form-group">
                      <input
                        type="text"
                        name={`percentage_cgpa-${index}`}
                        value={education.percentage_cgpa || ""}
                        className="form-control"
                        placeholder="Percentage/CGPA"
                        onChange={(e) => handleEducationChange(e, index)}
                      />
                    </div>
                  </div>
                  <div className="col-md-4 mb-2">
                    <div className="form-group">
                      <input
                        type="text"
                        name={`university_roll_number-${index}`}
                        value={education.university_roll_number || ""}
                        className="form-control"
                        placeholder="University/Roll Number"
                        onChange={(e) => handleEducationChange(e, index)}
                      />
                    </div>
                  </div>

                  <div className="col-md-4 mb-2">
                    <div className="form-group">
                      <input
                        type="text"
                        name={`graduation_year-${index}`}
                        value={education.graduation_year || ""}
                        className="form-control"
                        placeholder="Graduation Year/Year of Pass"
                        onChange={(e) => handleEducationChange(e, index)}
                      />
                    </div>
                  </div>
                </div>

                <div className="row text-center">
                  <div className="col-md-4">
                    <div className="form-group">
                      <label className="form-label">Type</label>
                      <input
                        type="text"
                        name={`education_type-${index}`}
                        value={education.education_type || ""}
                        className="form-control"
                        placeholder="Full Time/Part Time"
                        onChange={(e) => handleEducationChange(e, index)}
                      />
                    </div>
                  </div>
                  <div className="col-md-4">
                    <div className="form-group">
                      <label className="form-label">Start Date</label>
                      <input
                        type="date"
                        name={`education_start_date-${index}`}
                        value={education.education_start_date || ""}
                        className="form-control"
                        onChange={(e) => handleEducationChange(e, index)}
                      />
                    </div>
                  </div>
                  <div className="col-md-4">
                    <div className="form-group">
                      <label className="form-label">End Date</label>
                      <input
                        type="date"
                        name={`education_end_date-${index}`}
                        value={education.education_end_date || ""}
                        className="form-control"
                        onChange={(e) => handleEducationChange(e, index)}
                      />
                    </div>
                  </div>
                </div>

                <button
                  type="button"
                  className="btn btn-outline-danger mt-2 text-center"
                  onClick={() => removeEducationField(index)}
                >
                  <i className="fa fa-trash"></i>
                </button>
              </div>
            ))}
          </section>

          <hr />

          {/* Skills Information Section */}
          <section className="form-section">
            <h4 className="text-center">Skills Information</h4>

            {/* Primary Skills */}
            <div className="row mb-2">
              <div className="col-md-2 d-flex align-items-start">
                <h5>
                  Primary Skills
                  <small className="text-muted" style={{ fontSize: "0.85rem" }}>
                    {" "}
                    (technologies where you have expertise)
                  </small>
                  <button
                    title="Add More Primary Skill"
                    type="button"
                    className="btn btn-outline-primary ms-2 p-1"
                    onClick={addPrimarySkill}
                  >
                    <i
                      className="fa-solid fa-circle-plus"
                      style={{ fontSize: "1.25rem" }}
                    ></i>
                  </button>
                </h5>
              </div>
              <div className="col-md-10">
                {primarySkills.map((skill, index) => (
                  <div key={index} className="row mb-2">
                    <div className="col-md-3 mb-2">
                      <input
                        type="text"
                        className="form-control"
                        placeholder={`Primary Skill ${index + 1}`}
                        value={skill.skill_name}
                        onChange={(e) =>
                          handlePrimarySkillChange(
                            index,
                            "skill_name",
                            e.target.value
                          )
                        }
                      />
                    </div>
                    <div className="col-md-3 mb-2">
                      <input
                        type="number"
                        className="form-control"
                        placeholder="Experience (years)"
                        value={skill.experience}
                        onChange={(e) =>
                          handlePrimarySkillChange(
                            index,
                            "experience",
                            e.target.value
                          )
                        }
                      />
                    </div>
                  </div>
                ))}
              </div>
            </div>

            {/* Secondary Skills */}
            <div className="row mb-2">
              <div className="col-md-2 d-flex align-items-start">
                <h5 className="text-center">
                  Secondary Skills{" "}
                  <button
                    type="button"
                    className="btn btn-outline-primary p-1"
                    onClick={addSecondarySkill}
                  >
                    <i
                      className="fa-solid fa-circle-plus"
                      style={{ fontSize: "1.25rem" }}
                    ></i>
                  </button>
                </h5>
              </div>
              <div className="col-md-10">
                {secondarySkills.map((skill, index) => (
                  <div key={index} className="row mb-2">
                    <div className="col-md-3 mb-2">
                      <input
                        type="text"
                        className="form-control"
                        placeholder={`Secondary Skill ${index + 1}`}
                        value={skill.skill_name}
                        onChange={(e) =>
                          handleSecondarySkillChange(
                            index,
                            "skill_name",
                            e.target.value
                          )
                        }
                      />
                    </div>
                    <div className="col-md-3">
                      <input
                        type="number"
                        className="form-control"
                        placeholder="Experience (years)"
                        value={skill.experience}
                        onChange={(e) =>
                          handleSecondarySkillChange(
                            index,
                            "experience",
                            e.target.value
                          )
                        }
                      />
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </section>

          <hr />

          {/* Section: Document Upload */}
          <section className="form-section">
            <h4 className="section-title">Documents to Upload</h4>
            <p className="text-danger text-start m-0">
              Supported formats: PDF, JPG, PNG,DOCX. Max file size: 5MB.
            </p>

            {/* Personal Documents Section */}
            <h5 className="sub-section-title text-center">
              Personal Documents
            </h5>
            {[
              "aadhar_card",
              "pan_card",
              "passport",
              "visa",
              "bank_passbook",
              "resume",
              "candidate_photo",
            ].map((doc, idx) => (
              <div className="form-group row" key={idx}>
                <label className="col-form-label col-md-3 col-12">
                  {doc
                    .replace(/_/g, " ")
                    .replace(/\b\w/g, (char) => char.toUpperCase())}
                  {doc === "resume" && (
                    <span className="text-muted">(Updated Resume)</span>
                  )}
                </label>
                <div className="col-12 col-md-6 mb-2">
                  <input
                    type="file"
                    name={doc}
                    className="form-control"
                    onChange={(e) => handleFileChange(e, doc)}
                    key={doc}
                    ref={(input) => input && (inputRef[doc] = input)} // Store input refs dynamically
                  />
                </div>
                <div className="col-12 col-md-3">
                  <button
                    className="btn btn-outline-danger"
                    type="button"
                    onClick={() => clearFile(doc, null, inputRef[doc])}
                  >
                    <i className="fa-solid fa-trash"></i>
                  </button>
                </div>
              </div>
            ))}

            {/* Education Section */}
            <h5 className="sub-section-title text-center">
              Education Documents
            </h5>
            {[
              "tenth_marksheet",
              "tenth_certificate",
              "pu_marksheet",
              "pu_certificate",
              "degree_consolidated_marksheet",
              "degree_certificate",
              "post_degree_marksheet",
              "post_degree_certificate",
            ].map((doc, idx) => (
              <div className="form-group row" key={idx}>
                <label className="col-form-label col-12 col-md-3">
                  {doc
                    .replace(/_/g, " ")
                    .replace(/\b\w/g, (char) => char.toUpperCase())}
                  {doc === "degree_consolidated_marksheet" && (
                    <span className="text-muted">
                      (Include all semesters as a single PDF)
                    </span>
                  )}
                </label>
                <div className="col-12 col-md-6 mb-2">
                  <input
                    type="file"
                    name={doc}
                    className="form-control"
                    onChange={(e) => handleFileChange(e, doc)}
                    key={doc}
                    ref={(input) => input && (inputRef[doc] = input)} // Store input refs dynamically
                  />
                </div>
                <div className="col-12 col-md-3">
                  <button
                    className="btn btn-outline-danger"
                    type="button"
                    onClick={() => clearFile(doc, null, inputRef[doc])}
                  >
                    <i className="fa-solid fa-trash"></i>
                  </button>
                </div>
              </div>
            ))}

            {/* Experience Documents Section */}
            <h5 className="sub-section-title text-center">
              Experience Documents
            </h5>
            {uploadedDocuments.experience_letters.map((letter, index) => (
              <div
                className="form-group row"
                key={`experience_letter_${index}`}
              >
                <label className="col-form-label col-12 col-md-3">
                  Experience Letter{" "}
                  {index === 0
                    ? "(Last/Current Company)"
                    : `(Company ${index})`}
                </label>
                <div className="col-12 col-md-6 mb-2">
                  <input
                    type="file"
                    className="form-control"
                    onChange={(e) =>
                      handleFileChange(e, "experience_letters", index)
                    }
                    ref={(input) =>
                      input && (inputRef[`experience_letter_${index}`] = input)
                    }
                  />
                </div>
                <div className="col-12 col-md-3">
                  <button
                    className="btn btn-outline-danger"
                    type="button"
                    onClick={() => {
                      // Remove the file from the experience_letters array
                      setUploadedDocuments((prev) => {
                        const updatedExperienceLetters = [
                          ...prev.experience_letters,
                        ];
                        updatedExperienceLetters.splice(index, 1); // Remove the selected file
                        return {
                          ...prev,
                          experience_letters: updatedExperienceLetters,
                        };
                      });
                    }}
                  >
                    <i className="fa-solid fa-trash"></i>
                  </button>
                </div>
              </div>
            ))}

            {/* Relieving Documents Section */}
            <h5 className="sub-section-title text-center">
              Relieving Documents
            </h5>
            {uploadedDocuments.relieving_letters.map((letter, index) => (
              <div className="form-group row" key={`relieving_letter_${index}`}>
                <label className="col-form-label col-12 col-md-3">
                  Relieving Letter{" "}
                  {index === 0
                    ? "(Last/Current Company)"
                    : `(Company ${index})`}
                </label>
                <div className="col-12 col-md-6 mb-2">
                  <input
                    type="file"
                    className="form-control"
                    onChange={(e) =>
                      handleFileChange(e, "relieving_letters", index)
                    }
                    ref={(input) =>
                      input && (inputRef[`relieving_letter_${index}`] = input)
                    }
                  />
                </div>
                <div className="col-12 col-md-3">
                  <button
                    className="btn btn-outline-danger"
                    type="button"
                    onClick={() => {
                      // Remove the file from the relieving_letters array
                      setUploadedDocuments((prev) => {
                        const updatedRelievingLetters = [
                          ...prev.relieving_letters,
                        ];
                        updatedRelievingLetters.splice(index, 1); // Remove the selected file
                        return {
                          ...prev,
                          relieving_letters: updatedRelievingLetters,
                        };
                      });
                    }}
                  >
                    <i className="fa-solid fa-trash"></i>
                  </button>
                </div>
              </div>
            ))}

            {/* Add More Experience or Relieving Button */}
            <div className="form-group row mt-2">
              <div className="col-12 text-center">
                <button
                  className="btn btn-outline-primary"
                  onClick={() =>
                    setUploadedDocuments((prev) => ({
                      ...prev,
                      experience_letters: [...prev.experience_letters, null],
                      relieving_letters: [...prev.relieving_letters, null],
                    }))
                  }
                >
                  <i className="fa-solid fa-plus"></i> Add Experience and
                  Relieving Documents
                </button>
              </div>
            </div>
          </section>

          <hr />
          {/* Section: Criminal Record */}
          <section className="form-section text-center">
            <h4 className="section-title">Criminal Record Declaration</h4>

            {/* Question 1: Have you ever been convicted of a criminal offense? */}
            <div className="form-group">
              <label htmlFor="criminal_record" className="form-label">
                Have you ever been convicted of a criminal offense?
              </label>
              <div>
                <div className="form-check form-check-inline">
                  <input
                    type="radio"
                    className="form-check-input border-dark"
                    name="criminal_record"
                    value="yes"
                    checked={criminalRecord.criminal_record === "yes"}
                    onChange={handleCriminalRecordChange}
                  />
                  <label className="form-check-label">Yes</label>
                </div>
                <div className="form-check form-check-inline">
                  <input
                    type="radio"
                    className="form-check-input border-dark"
                    name="criminal_record"
                    value="no"
                    checked={criminalRecord.criminal_record === "no"}
                    onChange={handleCriminalRecordChange}
                  />
                  <label className="form-check-label">No</label>
                </div>
              </div>
            </div>

            {/* Show additional fields if "Yes" is selected */}
            {criminalRecord.criminal_record === "yes" && (
              <>
                {/* Question 2: Please provide details of the conviction */}
                <div className="form-group">
                  <label htmlFor="conviction_details" className="form-label">
                    Please provide details of the conviction:
                  </label>
                  <textarea
                    name="conviction_details"
                    className="form-control"
                    value={criminalRecord.conviction_details}
                    onChange={handleCriminalRecordChange}
                    rows={1}
                  />
                </div>

                {/* Question 3: Have you completed any rehabilitation programs or served the sentence? */}
                <div className="form-group mt-2">
                  <label className="form-label">
                    Have you completed any rehabilitation programs or served the
                    sentence?
                  </label>
                  <div>
                    <div className="form-check form-check-inline">
                      <input
                        type="radio"
                        className="form-check-input border-dark"
                        name="completed_rehabilitation"
                        value="yes"
                        checked={
                          criminalRecord.completed_rehabilitation === "yes"
                        }
                        onChange={handleCriminalRecordChange}
                      />
                      <label className="form-check-label">Yes</label>
                    </div>
                    <div className="form-check form-check-inline">
                      <input
                        type="radio"
                        className="form-check-input border-dark"
                        name="completed_rehabilitation"
                        value="no"
                        checked={
                          criminalRecord.completed_rehabilitation === "no"
                        }
                        onChange={handleCriminalRecordChange}
                      />
                      <label className="form-check-label">No</label>
                    </div>
                  </div>
                </div>

                {/* Question 4: Do you have any pending criminal cases? */}
                <div className="form-group mt-2">
                  <label className="form-label">
                    Do you have any pending criminal cases?
                  </label>
                  <div>
                    <div className="form-check form-check-inline">
                      <input
                        type="radio"
                        className="form-check-input border-dark"
                        name="pending_cases"
                        value="yes"
                        checked={criminalRecord.pending_cases === "yes"}
                        onChange={handleCriminalRecordChange}
                      />
                      <label className="form-check-label">Yes</label>
                    </div>
                    <div className="form-check form-check-inline">
                      <input
                        type="radio"
                        className="form-check-input border-dark"
                        name="pending_cases"
                        value="no"
                        checked={criminalRecord.pending_cases === "no"}
                        onChange={handleCriminalRecordChange}
                      />
                      <label className="form-check-label">No</label>
                    </div>
                  </div>
                </div>
              </>
            )}
          </section>

          <hr />
          {/* Section: Health Record */}
          <section className="form-section text-center">
            <h4 className="section-title">Health Record Declaration</h4>

            {/* Question 1: Do you have any medical conditions that may affect your work? */}
            <div className="form-group">
              <label htmlFor="medical_conditions" className="form-label">
                Do you have any medical conditions that may affect your work?
              </label>
              <div>
                <div className="form-check form-check-inline">
                  <input
                    type="radio"
                    className="form-check-input border-dark"
                    name="medical_conditions"
                    value="yes"
                    checked={healthRecord.medical_conditions === "yes"}
                    onChange={handleHealthRecordChange}
                  />
                  <label className="form-check-label">Yes</label>
                </div>
                <div className="form-check form-check-inline">
                  <input
                    type="radio"
                    className="form-check-input border-dark"
                    name="medical_conditions"
                    value="no"
                    checked={healthRecord.medical_conditions === "no"}
                    onChange={handleHealthRecordChange}
                  />
                  <label className="form-check-label">No</label>
                </div>
              </div>
            </div>

            {/* Show additional fields if "Yes" is selected for medical conditions */}
            {healthRecord.medical_conditions === "yes" && (
              <div className="form-group">
                <label
                  htmlFor="medical_conditions_details"
                  className="form-label"
                >
                  Please provide details of the medical condition:
                </label>
                <textarea
                  name="medical_conditions_details"
                  className="form-control"
                  value={healthRecord.medical_conditions_details}
                  onChange={handleHealthRecordChange}
                  rows={1}
                />
              </div>
            )}

            {/* Question 2: Have you undergone any recent health screening? */}
            <div className="form-group mt-2">
              <label className="form-label">
                Have you undergone any recent health screening?
              </label>
              <div>
                <div className="form-check form-check-inline">
                  <input
                    type="radio"
                    className="form-check-input border-dark"
                    name="recent_health_screening"
                    value="yes"
                    checked={healthRecord.recent_health_screening === "yes"}
                    onChange={handleHealthRecordChange}
                  />
                  <label className="form-check-label">Yes</label>
                </div>
                <div className="form-check form-check-inline">
                  <input
                    type="radio"
                    className="form-check-input border-dark"
                    name="recent_health_screening"
                    value="no"
                    checked={healthRecord.recent_health_screening === "no"}
                    onChange={handleHealthRecordChange}
                  />
                  <label className="form-check-label">No</label>
                </div>
              </div>
            </div>

            {/* Show additional fields if "Yes" is selected for recent health screening */}
            {healthRecord.recent_health_screening === "yes" && (
              <div className="form-group">
                <label
                  htmlFor="health_screening_details"
                  className="form-label"
                >
                  Please provide details of the health screening:
                </label>
                <textarea
                  name="health_screening_details"
                  className="form-control"
                  value={healthRecord.health_screening_details}
                  onChange={handleHealthRecordChange}
                  rows={1}
                />
              </div>
            )}

            {/* Question 3: Do you have any allergies or other conditions that we should be aware of? */}
            <div className="form-group mt-2">
              <label className="form-label">
                Do you have any allergies or other conditions that we should be
                aware of?
              </label>
              <div>
                <div className="form-check form-check-inline">
                  <input
                    type="radio"
                    className="form-check-input border-dark"
                    name="allergies_or_conditions"
                    value="yes"
                    checked={healthRecord.allergies_or_conditions === "yes"}
                    onChange={handleHealthRecordChange}
                  />
                  <label className="form-check-label">Yes</label>
                </div>
                <div className="form-check form-check-inline">
                  <input
                    type="radio"
                    className="form-check-input border-dark"
                    name="allergies_or_conditions"
                    value="no"
                    checked={healthRecord.allergies_or_conditions === "no"}
                    onChange={handleHealthRecordChange}
                  />
                  <label className="form-check-label">No</label>
                </div>
              </div>
            </div>

            {/* Show additional fields if "Yes" is selected for allergies or conditions */}
            {healthRecord.allergies_or_conditions === "yes" && (
              <div className="form-group">
                <label
                  htmlFor="emergency_condition_details"
                  className="form-label"
                >
                  Please provide details of the allergy or condition:
                </label>
                <textarea
                  name="emergency_condition_details"
                  className="form-control"
                  value={healthRecord.emergency_condition_details}
                  onChange={handleHealthRecordChange}
                  rows={1}
                />
              </div>
            )}

            {/* Question 4: Do you consent to company-mandated health screenings? */}
            <div className="form-group mt-2">
              <label className="form-label">
                Do you consent to company-mandated health screenings?
              </label>
              <div>
                <div className="form-check form-check-inline">
                  <input
                    type="radio"
                    className="form-check-input border-dark"
                    name="health_check_consent"
                    value="yes"
                    checked={healthRecord.health_check_consent === "yes"}
                    onChange={handleHealthRecordChange}
                  />
                  <label className="form-check-label">Yes</label>
                </div>
                <div className="form-check form-check-inline">
                  <input
                    type="radio"
                    className="form-check-input border-dark"
                    name="health_check_consent"
                    value="no"
                    checked={healthRecord.health_check_consent === "no"}
                    onChange={handleHealthRecordChange}
                  />
                  <label className="form-check-label">No</label>
                </div>
              </div>
            </div>
          </section>

          <hr />

          {/* Section: Declaration */}
          <section className="form-section text-center">
            <div className="form-group form-check">
              <input
                type="checkbox"
                className="form-check-input border-dark"
                id="declarationCheck"
                checked={isDeclarationChecked}
                onChange={() => setIsDeclarationChecked(!isDeclarationChecked)}
                required
              />
              <label className="form-check-label" htmlFor="declarationCheck">
                I declare that the information provided is true and accurate to
                the best of my knowledge.
              </label>
            </div>
          </section>

          {/* Submit Button */}
          <div className="text-center">
            <button type="submit" className="btn btn-success mt-4">
              Submit
            </button>
            <button
              type="button"
              onClick={handleSaveDraft}
              className="btn btn-primary mt-4 ms-1"
            >
              Save Draft
            </button>
          </div>
        </form>
      </div>
    </>
  );
};

export default OnboardingForm;
